import { SocialAccountManager } from '@/components/profile/SocialAccountManager';
import { SecurityPanel } from '@/components/profile/SecurityPanel';
import { PayoutPanel } from '@/components/profile/PayoutPanel';
import LogoutButton from '@/components/profile/LogoutButton';
import PayoutHistory from '@/components/profile/PayoutHistory';
import { AffiliateSection } from '@/components/profile/AffiliateSection';
import SupportBox from '@/components/profile/SupportBox';

export default function ProfilePage() {
  return (
    <section className="space-y-5 pb-24 lg:pb-8">
      <header>
        <p className="text-sm uppercase tracking-wide text-lime-300">Creator settings</p>
        <h1 className="text-2xl font-semibold text-white lg:text-3xl">Profile & payouts</h1>
        <p className="text-sm text-white/60">
          Manage login credentials, connected channels, and payout preferences.
        </p>
      </header>

      <div className="lg:grid lg:grid-cols-2 lg:gap-6">
        <div className="space-y-5">
          <SocialAccountManager />
          <SecurityPanel />
          <SupportBox />
        </div>
        
        <div>
          <PayoutPanel />
          <div className="mt-6">
            <PayoutHistory />
          </div>
          <div className="mt-6">
            <AffiliateSection />
          </div>
        </div>
      </div>

      <div className="pt-6">
        <div className="flex justify-center">
          <LogoutButton />
        </div>
      </div>
    </section>
  );
}
